import axiosApiInstance from "../app/axios";
import { PARKIT_API_BASE_URL } from "../app/utils";
import { getJwtToken } from "../app/common";

export const getAllPayoutReports = async (page, size, sort, sortBy) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/payout-reports?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const downloadPayoutReports = async (id) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/payout-reports/${id}/download`,
    {
      headers: { Authorization: `Bearer ${getJwtToken()}` },
      responseType: "blob",
    }
  );

export const getAllPayouts = async (page, size, sort, sortBy, filter, search) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/payouts?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}${
      filter ? "&filter=" + filter : ""
    }${search ? "&search=" + encodeURIComponent(search) : ""}`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const downloadPayoutReceipt = async (id) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/payouts/${id}/download`,
    {
      headers: { Authorization: `Bearer ${getJwtToken()}` },
      responseType: "blob",
    }
  );

export const uploadPayoutFile = async (formData) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/payouts/upload`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${getJwtToken()}`,
        "Content-Type": `multipart/form-data`,
      },
    }
  );

export const requestPayoutOtp = async (authorizer, payouts) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/payouts/otp/${authorizer}`,
    payouts,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const transferPayout = async (otp, payouts) =>
  axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/payouts/transfer`,
    payouts,
    {
      headers: {
        Authorization: `Bearer ${getJwtToken()}`,
        OTP: otp,
      },
    }
  );

export const updatePayoutStatus = async (id) =>
  axiosApiInstance.put(
    `${PARKIT_API_BASE_URL}/parkit/v2/payouts/${id}/update-status`,
    null,
    {
      headers: {
        Authorization: `Bearer ${getJwtToken()}`,
      },
    }
  );

export const updatePayout = async (id, payout) =>
  axiosApiInstance.put(
    `${PARKIT_API_BASE_URL}/parkit/v2/payouts/${id}`,
    payout,
    {
      headers: {
        Authorization: `Bearer ${getJwtToken()}`,
      },
    }
  );

export const getPayoutOverview = async (year, month) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/payouts/overview?year=${year}&month=${month}`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const downloadPayouts = async (year, month) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/payouts/download?year=${year}&month=${month}`,
    {
      headers: { Authorization: `Bearer ${getJwtToken()}` },
      responseType: "blob",
    }
  );

export const bulkTransferPreview = async (year, month) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/payouts/bulk-transfer-preview?year=${year}&month=${month}`,
    {
      headers: { Authorization: `Bearer ${getJwtToken()}` },
    }
  );
